export default __webpack_public_path__ + "static/media/Imagethree.52b250f9.jpeg";